import {
  ChangeDetectionStrategy,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
} from '@angular/core';

import { AppSharedModule } from '../../../../../app-shared.module';
import { SENTIMENT_COLORS } from '../sentiment-bar/sentiment-bar.component';
import { PercentageSentiment } from '../../numeric-metadata-field-selector/numeric-metadata-field-selector.models';

@Component({
  selector: 'app-sentiment-icon',
  imports: [AppSharedModule],
  templateUrl: './sentiment-icon.component.html',
  styleUrl: './sentiment-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SentimentIconComponent {
  sentiment = input.required<PercentageSentiment>();

  icon = computed(() => this.SENTIMENT_ICON_MAP[this.sentiment()]);
  color = computed(() => SENTIMENT_COLORS[this.sentiment()]);

  readonly SENTIMENT_ICON_MAP = {
    'very positive': 'sentiment_very_satisfied',
    'somewhat positive': 'sentiment_satisfied_alt',
    positive: 'sentiment_very_satisfied',
    neutral: 'sentiment_dissatisfied',
    negative: 'mood_bad',
    'somewhat negative': 'sentiment_very_dissatisfied',
    'very negative': 'mood_bad',
  };
}
